import '~/assets/scss/analytic.scss'

import findForm from '~/js/modules/find-form';
import '~/js/modules/promo-banner';

window.addEventListener(`DOMContentLoaded`, () => {
    const findForms = document.querySelectorAll(`.js-find-form`);
    if (findForms.length) {
      findForms.forEach((form, i) => new findForm(form));
    }
});
